import styled from "@emotion/styled";
import { Avatar, Box, Typography } from "@mui/material";

export const MessageBox = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isAdmin",
})(
  ({ theme, isAdmin }) => `
  border-radius: 10px 10px 0 10px;
  height: 100%;
  max-width : 60%;
  background: ${
    isAdmin ? "rgba(118, 118, 118, 0.3)" : `${theme.palette.primary.main}`
  };
  border: 1px solid rgba(118, 118, 118, 0.3);
  margin: 5px;
  font-size: 15px;
  padding: 5px 10px;
  color : ${isAdmin ? "" : "#fff"} ;
  word-break: break-word;

  h6 {
    color :  ${isAdmin ? "#75756c" : "#c7c9d4"} ;
    font-size : 11px;
  }

  `
);

export const StyledAvatar = styled(Avatar)(
  () =>
    `
    background: rgb(19, 38, 73);
    height:30px;
    width:30px;
  `
);

export const ConversationBox = styled(Box)(
  () =>
    `
    overflow-y: auto;
    max-height: 100vh;
  `
);

export const NoConversationBox = styled(Box)(
  () =>
    `
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top : 20px;
  `
);

export const QuestionOptionBox = styled(Box)(
  ({ theme }) => `

background-color: #3064AA;
padding: 7px;
font-size: 12px;
border-radius: 7px;
cursor: pointer;
opacity: 0.8;
margin: 10px;
background :${theme.palette.primary.main};
color:#fff;
&:hover  {
  opacity:0.7 
},
`
);

export const Loader = styled("img")`
  max-width: 50px;
  width: 100%;
  height: 50px;
  display: block;
`;
